var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountLinking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 97,
    viewBox: "0 0 98 97",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_618_908)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_618_908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 97
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2577 49.4286C67.2577 59.9281 58.7753 68.4286 48.3253 68.4286C37.8752 68.4286 29.3928 59.9281 29.3928 49.4286C29.3928 38.9291 37.8752 30.4286 48.3253 30.4286C58.7753 30.4286 67.2577 38.9291 67.2577 49.4286Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4421 7.85717C54.4421 11.0192 51.8888 13.5715 48.7527 13.5715C45.6165 13.5715 43.0632 11.0192 43.0632 7.85717C43.0632 4.69518 45.6165 2.14288 48.7527 2.14288C51.8888 2.14288 54.4421 4.69518 54.4421 7.85717Z",
    stroke: "white",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59 23.6104C24.6463 21.5475 24.6463 18.2028 22.59 16.1398C20.5337 14.0769 17.1998 14.0769 15.1434 16.1398C13.0871 18.2028 13.0871 21.5475 15.1434 23.6104C17.1998 25.6733 20.5337 25.6733 22.59 23.6104Z",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7002 73.5682C72.4701 75.8055 72.4701 79.4329 74.7002 81.6701C76.9303 83.9074 80.546 83.9074 82.776 81.6702C85.0061 79.4329 85.0061 75.8055 82.776 73.5682C80.546 71.331 76.9303 71.331 74.7002 73.5682Z",
    stroke: "white",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.063 88.4286C43.063 85.2666 45.6164 82.7143 48.7525 82.7143C51.8887 82.7143 54.442 85.2666 54.442 88.4286C54.442 91.5906 51.8887 94.1429 48.7525 94.1429C45.6164 94.1429 43.063 91.5906 43.063 88.4286Z",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0961 23.6103C76.1524 25.6733 79.4863 25.6733 81.5426 23.6103C83.5989 21.5474 83.5989 18.2027 81.5426 16.1397C79.4863 14.0768 76.1524 14.0768 74.0961 16.1397C72.0397 18.2027 72.0397 21.5474 74.0961 23.6103Z",
    stroke: "white",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4088 73.2107C21.3525 71.1477 18.0186 71.1477 15.9623 73.2107C13.906 75.2736 13.906 78.6183 15.9623 80.6812C18.0186 82.7442 21.3525 82.7442 23.4088 80.6812C25.4651 78.6183 25.4651 75.2736 23.4088 73.2107Z",
    stroke: "white",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.763 53.8572C86.6269 53.8572 84.0735 51.3049 84.0735 48.1429C84.0735 44.9809 86.6269 42.4286 89.763 42.4286C92.8992 42.4286 95.4525 44.9809 95.4525 48.1429C95.4525 51.3049 92.8992 53.8572 89.763 53.8572Z",
    stroke: "white",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74197 42.4286C10.8781 42.4286 13.4314 44.9809 13.4314 48.1429C13.4314 51.3049 10.8781 53.8572 7.74197 53.8572C4.60582 53.8572 2.05249 51.3049 2.05249 48.1429C2.05249 44.9809 4.60582 42.4286 7.74197 42.4286Z",
    stroke: "white",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7524 29.2857V14.7143",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5567 35.0095L23.7251 24.1429",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5881 63.0263L73.1026 72.5715",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7524 69.5714V82",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9841 35.3645L73.7424 24.5715",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0626 62.9197L23.5481 72.4648",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 49H83.3551",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2471 48.1429H14.5769",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_618_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8982 103C77.6257 103 101.725 78.8234 101.725 49C101.725 19.1766 77.6257 -5 47.8982 -5C18.1707 -5 -5.92822 19.1766 -5.92822 49C-5.92822 78.8234 18.1707 103 47.8982 103Z",
    fill: "#CB0000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_618_908",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 39,
    width: 23,
    height: 20
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8596 39.5714H37.6455V58.4285H59.8596V39.5714Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_618_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8059 42.5448V39.5714H48.3096V47.6417C48.0594 45.2513 46.6382 43.1638 43.9999 43.1638C42.7285 43.1638 41.7557 43.6425 41.0606 44.6003H41.021V39.5714H37.6455V53.8201H40.8625V52.6225H40.9021C41.5581 53.6012 42.5503 54.1191 43.7419 54.1191C46.6629 54.1191 48.0632 51.8433 48.3081 49.2578V53.8211H59.8045V50.6272H52.0024V47.913H58.9524V45.0396H52.0024V42.5448H59.8059ZM42.9478 51.5258C41.4185 51.5258 40.9026 50.3486 40.9026 48.533C40.9026 46.397 42.0537 45.7591 42.9676 45.7591C44.4564 45.7591 44.9732 47.2154 44.9732 48.533C44.9727 49.9486 44.4564 51.5249 42.9473 51.5249L42.9478 51.5258Z",
    fill: "white",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7828 55.7749C58.7828 56.0361 58.6534 56.1822 58.3259 56.1822H57.7332V55.3831H58.3413C58.6582 55.3831 58.7828 55.5443 58.7828 55.7749ZM59.8595 58.2148L59.1311 56.8196C59.5316 56.637 59.7861 56.2972 59.7861 55.7516C59.7861 54.8841 59.22 54.5598 58.3674 54.5598H56.7405V58.2172H57.7332V56.9822H58.1385L58.7316 58.2148H59.8595ZM56.2826 56.6526V54.5573H55.2533V56.6526C55.2533 57.1021 55.0866 57.3808 54.692 57.3808C54.2973 57.3808 54.1205 57.1041 54.1205 56.6526V54.5573H53.0902V56.6526C53.0902 57.8123 53.7612 58.2721 54.6765 58.2721C55.5919 58.2721 56.2826 57.8123 56.2826 56.6526ZM51.7392 56.3914C51.7392 57.0497 51.5102 57.3895 51.1044 57.3895C50.6987 57.3895 50.4601 57.0395 50.4601 56.3807C50.4601 55.722 50.6885 55.3831 51.0943 55.3831C51.5 55.3831 51.7392 55.7331 51.7392 56.3914ZM52.7835 56.3807C52.7835 55.1637 52.0927 54.5001 51.1044 54.5001C50.1161 54.5001 49.4138 55.1739 49.4138 56.3933C49.4138 57.6128 50.1045 58.274 51.0928 58.274C52.0811 58.274 52.7835 57.6002 52.7835 56.3807ZM49.0641 54.5573H48.0309V58.2148H49.0607L49.0641 54.5573ZM47.7483 54.5573H46.6233L46.3581 55.5394C46.233 55.9996 46.0562 56.7361 45.9886 57.0861C45.9214 56.7361 45.7441 55.9943 45.62 55.5394L45.3543 54.5573H44.2211L45.4741 58.2148H46.4933L47.7483 54.5573ZM43.2265 56.7676H42.6208L42.6884 56.5249C42.8184 56.0603 42.8754 55.8559 42.9222 55.6108C42.9705 55.8535 43.0261 56.0555 43.1565 56.5249L43.2265 56.7676ZM44.7597 58.2148L43.4391 54.5573H42.4174L41.0973 58.2148H42.1788L42.3764 57.5711H43.4681L43.6656 58.2138L44.7597 58.2148ZM40.8398 58.2148V54.5573H39.8081V55.8899H38.6748V54.5573H37.6455V58.2148H38.6748V56.773H39.8081V58.2148H40.8398Z",
    fill: "white",
    fillOpacity: 0.87
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_618_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 97,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLinking);
export default __webpack_public_path__ + "static/media/account-linking.70d65a802ebc2e4b32d723846a72b2e9.svg";
export { ForwardRef as ReactComponent };